import { render, staticRenderFns } from "./RankingBoard.vue?vue&type=template&id=17813810&scoped=true"
import script from "./RankingBoard.vue?vue&type=script&lang=js"
export * from "./RankingBoard.vue?vue&type=script&lang=js"
import style0 from "./RankingBoard.vue?vue&type=style&index=0&id=17813810&prod&scoped=true&lang=css"
import style1 from "./RankingBoard.mobile.css?vue&type=style&index=1&id=17813810&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17813810",
  null
  
)

export default component.exports